import { isArray, keys } from '../shortcut'

/**
 * 获取可遍历的键集合
 */
export function getIterableKeys(target?: any): string[] {
  if (!target) return []
  if (typeof target.getIterableKeys === 'function')
    return target.getIterableKeys()
  if (isArray(target) || target instanceof Map || target instanceof Set)
    return Array.from(target.keys())
  if (typeof target === 'object')
    return keys(target).filter((key) => !key.includes('__rr_'))
  return []
}
